export default [
  {
    path: '/api',
    name: 'api-doc',
    component: () => import('@/features/apiDoc/views/ApiDoc.vue'),
  },
];
